module.exports = __webpack_public_path__ + "img/emoticon-nps-10-on.576c662a.svg";